/**
 * Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { SnackbarProvider } from 'notistack';

import App from './App';
import { store } from './store';
import { theme } from './theme';

import 'mapbox-gl/dist/mapbox-gl.css';
import './index.css';

// Log version on app startup
console.log('Assetrac Version:', import.meta.env.VITE_APP_VERSION || '1.0.0');

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            autoHideDuration={3000}
          >
            <App />
          </SnackbarProvider>
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );
} else {
  console.error('Root element not found');
}
